
import React, { createContext, useState, useMemo } from "react";

import useDataApi from "../hooks/useDataApi";
import { fnCreateNewForm, fnUpdateForm } from "../services/forms";

export const FormContext = createContext(null);

export const FormContextProvider = ({ children }) => {
    const [ofnCreateNewFormRes, fnGetfnCreateNewFormReq] = useDataApi(fnCreateNewForm)
    const [ofnUpdateFormRes, fnGetfnUpdateFormReq] = useDataApi(fnUpdateForm)
    const [bIsEditForm, fnSetBIsEditForm] = useState(false)
    const [bOpenNewForm, fnSetBOpenNewForm] = useState(false)
    const [bShareForm, fnSetBShareForm] = useState(false)
    const [oForm, fnSetOForm] = useState({})

    const [bUpdateFormList, fnSetBUpdateFormList] = useState(false)

    async function fnNewForm(data) {
        const response = await fnGetfnCreateNewFormReq(data)
        return response.success
    }

    async function fnUpdateFormActivity(nFormId, data) {
        const response = await fnGetfnUpdateFormReq(nFormId, data)
        return response.success
    }

    function fnOpenNewForm(oForm) {
        fnSetBOpenNewForm(true)

        if (oForm?.id) {
            fnSetOForm(oForm)
            fnSetBIsEditForm(true)
            return
        }

        fnSetBIsEditForm(false)
    }
    function fnOpenShareForm(data) {
        fnSetBOpenNewForm(true)
        fnSetBShareForm(true)
        fnSetOForm(data)
    }

    function fnCloseNewForm() {
        fnSetBOpenNewForm(false)
        fnSetBShareForm(false)
        fnSetBIsEditForm(false)
        fnSetOForm({})
    }


    const value = useMemo(() => {
        return {
            ofnCreateNewFormRes,
            fnNewForm,
            bUpdateFormList,
            fnSetBUpdateFormList,
            ofnUpdateFormRes,
            fnUpdateFormActivity,
            bIsEditForm,
            fnSetBIsEditForm,
            bOpenNewForm,
            fnSetBOpenNewForm,
            bShareForm,
            fnSetBShareForm,
            fnOpenNewForm,
            fnOpenShareForm,
            oForm,
            fnCloseNewForm
        };
    }, [ofnCreateNewFormRes,
        fnNewForm,
        bUpdateFormList,
        ofnUpdateFormRes,
        fnUpdateFormActivity,
        bOpenNewForm,
        fnSetBOpenNewForm,
        bIsEditForm,
        fnSetBIsEditForm,
        oForm,
        fnSetOForm,
        fnCloseNewForm,
        fnOpenShareForm
    ]);

    return (
        <FormContext.Provider value={value}>
            {children}
        </FormContext.Provider>
    )
}

export default FormContext;